<template>
  <!-- 3.1新增供方回访任务 操作界面 -->
  <div class="content">
    <div class="top">
      <el-form ref="form" :model="form" label-width="140px" style="padding:20px;">
        <el-row>
          <el-col :span="6">
            <el-form-item label="姓名">
              <el-input :disabled="true" v-model="form.personName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工号">
              <el-input :disabled="true" v-model="form.personId"></el-input> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="部门">
              <el-input :disabled="true" v-model="form.personDept"></el-input> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="手机">
              <el-input :disabled="true" v-model="form.personPhone"></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="礼金金额">
              <el-input :disabled="true" v-model="form.money"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="礼品名称">
              <el-input :disabled="true" v-model="form.name"></el-input> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="礼品价值">
              <el-input :disabled="true" v-model="form.value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="送礼单位">
              <el-input :disabled="true" v-model="form.giverCompany"></el-input> </el-form-item
          ></el-col>
          
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="申报时间">
              <el-input :disabled="true" v-model="form.timeStr"></el-input> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="申报状态">
              <el-input :disabled="true" v-model="form.status"></el-input> </el-form-item
          ></el-col>
          <el-col :span="6">
            <el-form-item label="指派时间">
              <el-input :disabled="true" v-model="form.zpTimeStr"></el-input> </el-form-item
          ></el-col>
          
        </el-row>
        <el-row>
          <el-form-item label="礼品附件" style="text-align: left;">
            <Upload :disabled="true" :fileIds="appFileListIds"></Upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="处理人">
              <OrgPersonTreeSelect
                :parentId="parentId"
                :selectDisabled="isReadonly||form.status!='已申请'"
                :initValue="form.supervisePersonId?form.supervisePersonId.split(','):[]"
                :multipleSelect="false"
                :expandKeys="parentId"
                @getSelectValue="val=>{$set(form,'supervisePersonId',val.join(','))}"></OrgPersonTreeSelect>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="处理方式">
              <el-input :disabled="isReadonly||form.status=='已处理'" v-model="form.handleType"  maxlength="1000" show-word-limit type="textarea" :autosize="{minRows:3,maxRows:15}"></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-form-item label="处理附件" style="text-align: left;">
            <Upload :disabled="isReadonly" :fileIds="fileListIds" @getUploadFileIds="getUploadFileIds"></Upload>
          </el-form-item>
        </el-row>
        
        <el-row span="24" style="margin-top:20px;" v-if="!isReadonly">
            <el-col :span="2" :offset="9">
                <el-button type="primary" @click="save(false)">暂存</el-button>
            </el-col>
            <el-col :span="2" v-if="form.status == '已申请'&&form.fpr==Cookie.get('oguGuid')">
                <el-button type="primary" @click="zp">指派</el-button>
            </el-col>
            <el-col :span="2" v-if="form.status == '已指派'&&form.supervisePersonId==Cookie.get('oguGuid')">
                <el-button type="primary" @click="cl">处理</el-button>
            </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      parentId:'50020020',
      orgExpandKeys: ["50020020"],
      auditParentId:'50652940',
      auditOrgExpandKeys: ["50652940"],
      form:{},
      fileListIds:[],
      appFileListIds:[],
      isReadonly:true
    };
  },
  mounted(){
    this.form = {}
    this.form.guid = this.$route.query.guid
    if(this.form.guid){
      this.getData()
    }
    if(!this.form.guid){
      this.$message.error('参数错误');
    }
  },
  methods: {
    getData(){
      this.$http.get("/api/ts/v0.1/cashGift/"+this.form.guid)
      .then(res=>{
        res.data.timeStr = this.$handlerDateToDay(res.data.time)
        res.data.zpTimeStr = this.$handlerDateToDay(res.data.zpTime)
        this.form = res.data
        if(this.form.files){
          this.fileListIds = this.form.files.split(',')
        }else{
          this.fileListIds = []
        }
        if(this.form.appFiles){
          this.appFileListIds = this.form.appFiles.split(',')
        }else{
          this.appFileListIds = []
        }
        if((this.form.status == '已申请'&&this.form.fpr==this.Cookie.get('oguGuid'))||(this.form.status == '已指派'&&this.form.supervisePersonId==this.Cookie.get('oguGuid'))){
          this.isReadonly = false
        }else{
          this.isReadonly = true
        }
        
      })
    },
    zp(){
      if(!this.form.supervisePersonId){
        return this.$message.error('请填写处理人')
      }
      this.$confirm('请确认是否提交，提交后单据将不能修改。','提示'
      ,{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
      }).then(()=>{
        this.form.status = '已指派'
        this.form.spare = 'CL'
        this.save()
      })
      
    },
    cl(){
      if(!this.form.supervisePersonId){
        return this.$message.error('请填写处理人')
      }
      if(!this.form.handleType){
        return this.$message.error('请填写处理方式')
      }
      this.$confirm('请确认是否提交，提交后单据将不能修改。','提示'
      ,{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
      }).then(()=>{
        this.form.spare = 'CL'
        this.form.status = '已处理'
        this.save()
      })
    },
    save(){
        this.$http.post('/api/ts/v0.1/cashGift/save',this.form)
          .then(res=>{
              if (res.data >= 1) {
                  this.getData()
                  this.$message.success('操作成功')
              } else {
                  this.$message.error('操作失败')
              }
          })
          .catch((err)=>{
              this.$message.error('操作失败')
          })
    },
    getUploadFileIds(files){
      this.form.files = files.join(',')
    }

  },
};
</script>

<style scoped>
.content {
  display: flex;
}
.top {
  width: 100%;
}
.middle {
  margin-top: 60px;
  width: 100%;
}
</style>